export default __webpack_public_path__ + "static/media/ArticlesOfIncorporation.0a2eeba2.pdf";